import { render, staticRenderFns } from "./ColumnItem.vue?vue&type=template&id=27c3772a&"
import script from "./ColumnItem.vue?vue&type=script&lang=js&"
export * from "./ColumnItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports